import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoginCommand } from '../../commands/auth/login.command';
import { localStorageKeys } from '../constants/local.storage.keys';
import { ApiService } from './api.service';

@Injectable()
export class AuthService {
    public static get authorized() {
        return !!localStorage.getItem(localStorageKeys.authToken);
    }

    constructor(private router: Router, private apiService: ApiService) {
    }

    public login(command: LoginCommand): Observable<string> {
        return this.apiService.post('auth/login', command)
            .do(token => this.apiService.setAuthorizationHeader(token));
    }

    public logout() {
        this.apiService.clearAuthorizationHeader();
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/auth.service.ts